import React, { useEffect, useState, useCallback, useMemo } from "react";
import CustomButton from "../../components/Elements/Buttons/CustomButtons";
import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { useNavigate } from "react-router-dom";
import { SearchBar } from "../../components/Elements/Search/SearchBar";
import { Tables } from "../../components/Elements/Tables/Tables";
import { ReactComponent as EditIcon } from "../../assets/svgs/greenEdit.svg";
import { API_URLS } from "../../api/apiUrls";
import { getApi } from "../../api/api_instance";
import CreateStaticPageDialog from "./DialogBoxes/CreateStaticPageDialog";
import SortData from "../../components/Elements/SortData/SortData";
import PopupCard from "../../components/Cards/PopupCard/PopupCard";

const StaticPages = () => {
  const [staticPages, setStaticPages] = useState([]);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 5;
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [createStaticPageSuccess, setCreateStaticPageSuccess] = useState(false);
  const navigate = useNavigate();
  const [popup, setPopup] = useState({
    visible: false,
    type: "success",
    title: "",
    message: "",
  });

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Page", key: "pageHeading" },
      { label: "Description", key: "pageContent" },
      { label: "Action", key: "action" },
    ],
    []
  );

  const showPopup = (type, title, message) => {
    setPopup({ visible: true, type, title, message });
    setTimeout(() => {
      setPopup({ ...popup, visible: false });
    }, 3000);
  };

  const fetchStaticPages = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const response = await getApi({
          apiUrl: API_URLS.ALL_STATIC_PAGES(page, pageSize, searchTerm),
        });

        if (response.data.contentList) {
          const pageData = response.data.contentList.map((item, index) => ({
            key: item._id,
            serial: (page - 1) * pageSize + (index + 1),
            pageHeading: item.pageHeading,
            pageContent: item.pageContent,
            action: (
              <div className="flex gap-4 items-center">
                <EditIcon
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  onClick={() => {
                    navigate(`/setting/static-pages/${item._id}`, {
                      state: { pageData: item },
                    });
                  }}
                />
              </div>
            ),
          }));

          setStaticPages(pageData);
          setTotal(response.data.metadata?.totalDocs || 0);
        } else {
          setStaticPages([]);
          setTotal(0);
        }
      } catch (error) {
        console.error("Error fetching static pages:", error);
        setStaticPages([]);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    },
    [searchTerm, navigate]
  );

  useEffect(() => {
    fetchStaticPages(pageNo);
  }, [pageNo, searchTerm]);

  const handleSort = (key, order) => {
    setSortBy(key);
    setSortOrder(order);
  };

  const filteredData = useMemo(() => {
    let data = [...staticPages];

    if (sortBy && sortOrder) {
      data = SortData({ data, key: sortBy, order: sortOrder });
    }

    return data;
  }, [staticPages, sortBy, sortOrder]);

  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <div className="flex justify-end text-xs font-light p-3">
        <p>Home</p>
        <span>/</span>
        <TextStyles color="gradient">Static Pages</TextStyles>
      </div>

      <div>
        <div className="flex items-center mb-6 gap-2 text-xl text-[#06513D] font-bold px-2">
          {/* <Back onClick={() => navigate(-1)} className="cursor-pointer" /> */}
          <div>Static Pages</div>
        </div>

        <div
          style={{
            border: "1px solid #3BA2B959",
            borderRadius: "10px",
            paddingTop: "20px",
            boxShadow: "0px 0px 16px 0px #3BA2B91F",
          }}
        >
          <div className="flex justify-between px-3 mb-3">
            <div className="flex gap-4 pl-9">
              <SearchBar width="300px" onSearch={setSearchTerm} />
            </div>
            <div className="flex gap-4">
              <CustomButton
                buttonType="button"
                variant="ok"
                buttonText=" + Create New"
                onClick={() => setOpenCreateDialog(true)}
                className="text-base font-normal h-[50px] w-[160px]"
              />
            </div>
          </div>

          <Tables
            data={filteredData}
            headers={headers}
            pageSize={pageSize}
            current={pageNo}
            total={total}
            loading={loading}
            onChange={(page) => setPageNo(page)}
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSort={handleSort}
          />
        </div>

        {openCreateDialog && (
          <CreateStaticPageDialog
            onOpen={openCreateDialog}
            onClose={() => setOpenCreateDialog(false)}
            onSuccess={() => {
              setOpenCreateDialog(false);
              fetchStaticPages(pageNo);
            }}
            onSave={() => {
              showPopup(
                "success",
                "Created",
                "Static Page Created Successfully"
              );
            }}
            onError={(message) =>
              showPopup(
                "error",
                "Failed",
                message || "Failed to create static page"
              )
            }
          />
        )}

        {/* {createStaticPageSuccess && (
          <SuccessDailogBox
            onOpen={createStaticPageSuccess}
            onClose={() => setCreateStaticPageSuccess(false)}
            popuptype="success"
            successMessage={"Static Page Created Successfully"}
          />
        )} */}

        {popup.visible && (
          <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
            <PopupCard
              type={popup.type}
              title={popup.title}
              message={popup.message}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StaticPages;
